import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-loading-order-pdf',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './loading-order-pdf.component.html',
  styleUrl: './loading-order-pdf.component.scss'
})
export class LoadingOrderPdfComponent implements OnChanges{
  @Input() orderData: any; // Accept data as input
  @Input() transporters:any;
  @Input() vehicles:any;
  @Input() drivers:any;

  selectedTransporter:string;
  selectedVehicle:string;
  selectedDriver:string;
  selectedPlateNumber:string;
  qrCodeData = 'https://www.google.com/';
  baseUrl = window.location.origin; // Base URL
  qrCodeImage: string = '';

  
  constructor(private el: ElementRef) {}

  

  ngOnChanges(){
    // // debugger;
    //console.log(this.orderData);
    const driver=this.drivers?.find(driver=>driver.id==this.orderData?.driverId);
    this.selectedDriver=driver?.firstName + driver?.lastName;
    this.selectedTransporter=this.transporters?.find(trans=>trans.id==this.orderData?.transporterId)?.name;
    const vehicle=this.vehicles?.find(veh=>veh.id==this.orderData?.vehicleId);
    this.selectedVehicle=vehicle?.name;
    this.selectedPlateNumber=vehicle?.platNumber;
    this.qrCodeData=this.baseUrl+'/transactions/loading-order/view/'+this.orderData?.id;
    this.generateQRCode();
  }

  // Method to get the element (the part you want to use in html2pdf)
  getReportElement(): HTMLElement {
    // debugger
    return this.el.nativeElement.querySelector('#report-content'); // Assuming .report-content is the class for your report content
  }

  generateQRCode() {
    QRCode.toDataURL(this.qrCodeData, { width: 200 }, (err, url) => {
      if (err) {
        console.error('Error generating QR code:', err);
        return;
      }
      this.qrCodeImage = url;
    });
  }
}
